import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { format, subDays } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import * as React from 'react';
import { useMemo } from 'react';

import { DateFormatsEnum } from '../../../../constants/date';
import {
  ENABLE_ANONYMIZATION_WARNING_CONFIRM_LABEL,
  ENABLE_ANONYMIZATION_WARNING_PREFIX,
  ENABLE_ANONYMIZATION_WARNING_TITLE,
  getEnableAnonymizationWarningSuffix,
} from '../../../../constants/organizationsKeys';
import { detectUserTimezone } from '../../../../utils/date';
import { isValidCadence } from '../../../../utils/organizations';

interface IProps {
  open: boolean;
  cadenceDays?: number | null;
  onCancel: () => void;
  onConfirm: () => void;
}

const EnableAnonymizationWarningDialog: React.FC<IProps> = ({ open, cadenceDays, onCancel, onConfirm }) => {
  const cutoffDate = useMemo(() => {
    if (!isValidCadence(cadenceDays)) {
      return '';
    }

    const today = toZonedTime(new Date(), detectUserTimezone().utc[0]);

    return format(subDays(today, cadenceDays), DateFormatsEnum.ddMMMyyyy);
  }, [open, cadenceDays]);

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      fullWidth
      slotProps={{ paper: { sx: { maxWidth: 444 } } }}
      data-testid="enable-anonymization-warning-dialog"
    >
      <DialogTitle variant="h6">{ENABLE_ANONYMIZATION_WARNING_TITLE}</DialogTitle>
      <DialogContent>
        <DialogContentText color="text.secondary" variant="body1">
          {ENABLE_ANONYMIZATION_WARNING_PREFIX}
          <Box component="span" sx={{ fontWeight: 500, color: 'text.primary', whiteSpace: 'nowrap' }}>
            {cutoffDate}
          </Box>
          {isValidCadence(cadenceDays) && getEnableAnonymizationWarningSuffix(cadenceDays)}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={onCancel} data-action="cancel_anonymization_warning_btn">
          Cancel
        </Button>
        <Button variant="contained" onClick={onConfirm} data-action="confirm_anonymization_warning_btn">
          {ENABLE_ANONYMIZATION_WARNING_CONFIRM_LABEL}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EnableAnonymizationWarningDialog;
